export default "__VITE_ASSET__CopWA4Nf__"